(function (window, document, $) {
    "use strict";

    var app;
    var onready;
    var onload;
    var $w = $(window);
    var $d = $(document);
    var $b = $(document.body);
    var $header = $(document.getElementById("header"));
    var $content = $(document.getElementById("content"));
    var $footer = $(document.getElementById("footer"));

    app = {
        cookie: (function () {
            var set = function (name, value, options) {
                    options = options || {};

                    return document.cookie = [
                        name + "=" + encodeURIComponent(value),
                        options.expires ? "; expires=" + new Date(new Date().getTime() + (options.expires * 24 * 60 * 60 * 1000)).toUTCString() : "",
                        options.path ? "; path=" + options.path : ""
                    ].join("");
                },
                map = function () {
                    var map_cookies = {},
                        cookies = document.cookie.split('; '),
                        cookie,
                        i;

                    for (i = 0; i < cookies.length; i += 1) {
                        cookie = cookies[i].split('=');
                        map_cookies[cookie[0]] = decodeURIComponent(cookie[1]);
                    }

                    return map_cookies;
                },
                get = function (name) {
                    return this.map()[name];
                },
                remove = function (name, options) {
                    return this.set(name, '', $.extend({}, options, {expires: -1}));
                };

            return {
                set: set,
                map: map,
                get: get,
                remove: remove
            };
        }()),
        content: function () {
        }
    };

    onready = function () {
        app.content();

        $w.trigger("resize");
        $w.trigger("scroll");
    };
    onload = function () {
        window.loaded = true;
    };

    window.app = $.extend({}, window.app, {
        cookie: app.cookie
    });

    $(onready);
    $w.on("load", onload);

}(window, document, jQuery));